angular.module('picmonicng').filter('inArray', [
  '$filter',
  function ($filter) {
    return function (list, arrayFilter, element, subelement) {
      if (arrayFilter && arrayFilter.indexOf('') == -1) {
        return $filter('filter')(list, function (listItem) {
          if (listItem[element] && subelement) {
            return arrayFilter.indexOf(listItem[element][subelement].toString()) != -1;
          } else if (listItem[element]) {
            return arrayFilter.indexOf(listItem[element].toString()) != -1;
          } else {
            return false;
          }
        });
      } else {
        return list;
      }
    };
  },
]);
